<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-text1 animate-target" v-animate-in>Approved indication for finerenone<sup>1</sup></div>
    <div class="ctn-text2 animate-target" v-animate-in>Finerenone is indicated to delay progressive decline of kidney function and to reduce the risk of cardiovascular mortality and morbidity in adults with CKD (with albuminuria) associated with T2D in addition to standard of care.</div>
    <div class="ctn-text1 animate-target" v-animate-in>PBS criteria<sup>2</sup></div>
    <ul>
      <li class="animate-target" v-animate-in>Diagnosis of CKD with T2D. CKD, defined as abnormalities of at least one: (i) kidney structure, (ii) kidney function, present for at least 3 months prior to initiating treatment with this drug AND</li>
      <li class="animate-target" v-animate-in>eGFR of <b>25 mL/min/1.73 m<sup>2</sup></b> or greater AND</li>
      <li class="animate-target" v-animate-in>Albuminuria (UACR) of 200 mg/g <b>(22.6 mg/mmol)</b> or greater AND</li>
      <li class="animate-target" v-animate-in>must be stabilised, for at least 4 weeks, on either: (i) an ACE inhibitor or (ii) an angiotensin II receptor antagonist, unless medically contraindicated AND</li>
      <li class="animate-target" v-animate-in>treatment must be <b>in combination with an SGLT2i unless medically contraindicated or intolerant</b> AND</li>
      <li class="animate-target" v-animate-in>Must not be receiving treatment with another selective nonsteroidal MRA, a renin inhibitor or a potassium-sparing diuretic AND</li>
      <li class="animate-target" v-animate-in>Must not have established heart failure with reduced ejection fraction with an indication for treatment with a MRA AND</li>
      <li class="animate-target" v-animate-in>Must not have known significant non-diabetic renal disease, prior to initiating treatment with this drug AND</li>
      <li class="animate-target" v-animate-in>Must discontinue treatment with this drug prior to initiating renal replacement therapy, defined as dialysis or kidney transplant.</li>
    </ul>
    <GoNext class="animate-target" v-animate-in href="/section4/4-6">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";

export default {
  name: "s4-5",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"ACE, angiotensin-converting enzyme inhibitor; ARB, Angiotensin receptor blocker; CKD, chronic kidney disease; CV, cardiovascular; MRA, mineralocorticoid receptor antagonist; RACGP, Royal College of General Practitioner; SGLT-2, sodium-glucose co-transporter-2; T2D, type 2 diabetes.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. KERENDIA Product Information.<br/>"
      +"2. Pharmaceutical Benefits Scheme. Available at https://www.pbs.gov.au. Date accessed October 2023.",
      title:"Who would be eligible for nonsteroidal MRAs (finerenone)?"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section4/s4.css";
.ctn-text1 {
  color: #10384F;
  font-size: 24px;
  font-weight: bold;
  margin-top:20px;
}
.ctn-text2 {
  font-size: 20px;
  margin-top: 20px;
}
ul {
  margin-top: 20px;
  padding-left: 30px;
}
ul li {
  margin-bottom: 15px;
}
b {
  font-weight: bold;
}
</style>
